import api from "./api";

export async function PermissaoLogin(login, senha) {
  
  const response = await api.post("/auth/login", { login, senha });

  const data = response.data;
  if (data.token) {


        function extrairRoleDoToken(token) {
      try {
        const payloadBase64 = token.split('.')[1];
        const payloadJson = atob(payloadBase64);
        const payload = JSON.parse(payloadJson);

        return payload.role; 
      } catch (e) {
        console.error("Erro ao decodificar token:", e);
        return null;
      }
    }

    localStorage.setItem("token", data.token);
    localStorage.setItem("role", data.usuario.acesso.regra);
    localStorage.setItem("UserId", data.usuario.idCadastro);

    localStorage.setItem(
      "permissoes",
      JSON.stringify(data.usuario.acesso.regras)
    );
  }

  return data;
}




